import Box from '@mui/system/Box'
import CardMedia from '@mui/material/CardMedia'
import Typography from '@mui/material/Typography'
import Tooltip from '@mui/material/Tooltip'

const SingleAvatar = ({ name, imgUrl, active, variant, sxContainer, sxAvatar }) => {
  const nameInitials = (name) => {
    if (typeof name === 'string' || name instanceof String) {
      const namesArray = name.trim().split(' ')
      if (namesArray?.length === 1) return `${namesArray[0].charAt(0)}`
      else return `${namesArray[0].charAt(0)}${namesArray[namesArray?.length - 1].charAt(0)}`
    }
    if (name?.length > 0) {
      const firstName = name[0]
      const namesArray = firstName.trim().split(' ')
      if (namesArray?.length === 1) return `${namesArray[0].charAt(0)}`
      else return `${namesArray[0].charAt(0)}${namesArray[namesArray?.length - 1].charAt(0)}`
    }
  }

  return (
    <Box sx={{ ...sxContainer }}>
      {imgUrl ? (
        <CardMedia
          component="img"
          sx={{
            height: variant ? 40 : 52,
            width: variant ? 40 : 52,
            objectFit: 'cover',
            borderRadius: '50%',
            border: '3px solid',
            borderColor: active ? 'alternate.main' : 'gray-line.main',
            filter: active ? 'initial' : 'grayscale(100%)',
            ...sxAvatar,
          }}
          alt={`picture of ${name}`}
          src={imgUrl}
          loading="lazy"
        />
      ) : (
        <Box
          display="flex"
          justifyContent="center"
          alignItems="center"
          sx={{
            height: variant ? 40 : 52,
            width: variant ? 40 : 52,
            objectFit: 'cover',
            borderRadius: '50%',
            border: '3px solid',
            bgcolor: active ? 'alternate.main' : 'gray-line.main',
            borderColor: active ? 'alternate.main' : 'gray-line.main',
            ...sxAvatar,
          }}
        >
          <Typography variant={variant ? 'body1' : 'h4'} color="white.main">
            {nameInitials(name)}
          </Typography>
        </Box>
      )}
    </Box>
  )
}

const StepperAvatar = ({ name, imgUrl, active, sxAvatar, disableToolTip = false }) => {
  const avatarConstructor = (arr) => {
    if (!Array.isArray(arr)) {
      return <SingleAvatar name={name} imgUrl={arr} active={active} sxAvatar={sxAvatar} />
    } else if (arr.length === 2 && Array.isArray(arr)) {
      return arr.map((item, index) =>
        index === 1 ? (
          <SingleAvatar
            key={index}
            variant
            name={name[index]}
            imgUrl={item}
            active={active}
            sxContainer={{
              position: 'absolute',
              width: 40,
              height: 40,
              bottom: -3,
              right: 1,
              zIndex: 1,
            }}
            sxAvatar={sxAvatar}
          />
        ) : (
          <SingleAvatar
            key={index}
            variant
            name={name[index]}
            imgUrl={item}
            active={active}
            sxContainer={{
              position: 'absolute',
              width: 40,
              height: 40,
              top: -5,
              left: -3,
              zIndex: 1,
            }}
            sxAvatar={sxAvatar}
          />
        )
      )
    } else if (arr.length > 2 && Array.isArray(arr)) {
      return arr.map((item, index) =>
        index === 1 ? (
          <Tooltip
            key={index}
            disableHoverListener={disableToolTip}
            title={name.map((item, index) => (
              <Box key={index}>{item}</Box>
            ))}
          >
            <Box
              display="flex"
              alignItems="center"
              justifyContent="center"
              bgcolor="gray-background.main"
              borderRadius="50%"
              sx={{
                cursor: 'pointer',
                border: '3px solid',
                bgcolor: active ? 'alternate.main' : 'gray-line.main',
                borderColor: active ? 'alternate.main' : 'gray-line.main',
                position: 'absolute',
                width: 40,
                height: 40,
                bottom: -3,
                right: 1,
                zIndex: 2,
                ...sxAvatar,
              }}
            >
              <Typography variant="body1" color={active ? 'white.main' : 'light-gray-text.main'}>
                {arr.length - 1}
              </Typography>
            </Box>
          </Tooltip>
        ) : (
          <SingleAvatar
            key={index}
            variant
            name={name}
            imgUrl={item}
            active={active}
            sxContainer={{
              position: 'absolute',
              width: 40,
              height: 40,
              top: -5,
              left: -3,
              zIndex: 1,
            }}
            sxAvatar={sxAvatar}
          />
        )
      )
    } else {
      return <SingleAvatar name={name[0]} imgUrl={arr[0]} active={active} sxAvatar={sxAvatar} />
    }
  }
  return avatarConstructor(imgUrl)
}

export default StepperAvatar
